import type { ReactNode } from "react";
import { PencilSquareIcon, TrashIcon } from "@heroicons/react/24/outline";

/**
 * Kompakte Icon-Aktionen für Tabellenzeilen (Bearbeiten / Löschen). Ersetzt die
 * breiten Textbuttons in der angehefteten Aktionsspalte, damit mehr Platz für
 * die eigentlichen Daten bleibt.
 */
export function TableRowActions({
  onEdit,
  onDelete,
  editLabel = "Bearbeiten",
  deleteLabel = "Löschen",
  children,
  afterEdit,
}: {
  onEdit?: () => void;
  onDelete?: () => void;
  editLabel?: string;
  deleteLabel?: string;
  /** Zusätzliche Aktionen links von Bearbeiten/Löschen. */
  children?: ReactNode;
  /** Zusätzliche Aktionen zwischen Bearbeiten und Löschen. */
  afterEdit?: ReactNode;
}) {
  return (
    <div className="flex items-center justify-end gap-0.5">
      {children}
      {onEdit ? (
        <button
          type="button"
          className="eh-data-action-btn"
          title={editLabel}
          aria-label={editLabel}
          onClick={(event) => {
            event.stopPropagation();
            onEdit();
          }}
        >
          <PencilSquareIcon className="h-[18px] w-[18px]" aria-hidden />
        </button>
      ) : null}
      {afterEdit}
      {onDelete ? (
        <button
          type="button"
          className="eh-data-action-btn hover:!text-status-red"
          title={deleteLabel}
          aria-label={deleteLabel}
          onClick={(event) => {
            event.stopPropagation();
            onDelete();
          }}
        >
          <TrashIcon className="h-[18px] w-[18px]" aria-hidden />
        </button>
      ) : null}
    </div>
  );
}

/**
 * Kopfzellen-Breite der Aktionsspalte (36px je Button + Abstand + Zellen-Padding).
 * Statische Klassen, damit Tailwind sie beim Build erzeugt.
 */
export const ROW_ACTIONS_HEADER_CLASS = {
  two: "w-[84px]",
  three: "w-[122px]",
} as const;
